import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const SignUpPage = () => {
  const [loading, setLoading]=useState(false)
  const handleRegister=(e)=>{
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      setLoading(false)
    }, 2000);

  }
  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{
        backgroundImage: `url('assets/images/changan-bg/banner.jpg')`,
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        backgroundRepeat: 'no-repeat', 
      }}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-5 w-100 max-w-md radius-8"
        style={{maxWidth: "500px"}}
      >
        <div className="text-center mb-4">
          <img className="mb-3" src="assets/images/changan-logo/logo-with-text.png" alt="Logo" style={{ width: "50%" }}/>
          <p className="text-secondary-light text-sm">Don't have an account? Create your account, it takes less than a minute</p>
        </div>

        <form onSubmit={handleRegister}>
        <span className="text-sm text-secondary-light mb-2">Name</span>
        <div className='icon-field mb-16'>
          <span className='icon top-50 translate-middle-y'>
            <Icon icon='f7:person' />
          </span>
          <input
            type='text'
            className='form-control h-45-px bg-neutral-50 radius-5'
            placeholder='Name'
          />
        </div>

        <span className="text-sm text-secondary-light mb-2">Email Address</span>
        <div className='icon-field mb-16'>
          <span className='icon top-50 translate-middle-y'>
            <Icon icon='mage:email' />
          </span>
          <input
            type='email'
            className='form-control h-45-px bg-neutral-50 radius-5'
            placeholder='Email'
          />
        </div>

        <span className="text-sm text-secondary-light mb-2">Password</span>
        <div className='mb-10'>
          <div className='position-relative '>
            <div className='icon-field'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='solar:lock-password-outline'/>
              </span>
              <input
                type='password'
                className='form-control h-45-px bg-neutral-50 radius-5'
                id='your-password'
                placeholder='Password'
              />
            </div>
            <span
              className='toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
              data-toggle='#your-password'
            />
          </div>
          <span className='mt-8 text-sm text-muted'>
            Your password must have at least 8 characters
          </span>
        </div>
        <div className=''>
          <div className='d-flex justify-content-between gap-2'>
            <div className='form-check style-check d-flex align-items-start'>
              <input
                className='form-check-input border border-neutral-300 mt-4'
                type='checkbox'
                defaultValue=''
                id='condition'
              />
              <label
                className='form-check-label text-sm'
                htmlFor='condition'
              >
              I accept{" "}
                <Link to='https://changan.com.pk/terms-conditions.php' target="_blank" className='text-primary-600'>
                  Terms &amp; Conditions
                </Link>{" "}
                and {" "}
                <Link to='https://changan.com.pk/privacy-policy.php' target="_blank" className='text-primary-600'>
                  Privacy Policy
                </Link>
              </label>
            </div>
          </div>
        </div>
        <button
          type='submit'
          className='btn btn-primary text-sm btn-sm px-12 py-10 w-100 radius-5 mt-12' disabled={loading}
        >
           {loading ? (
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        ) : (
          "Sign Up"
        )}
        </button>

        <div className='mt-3 text-center text-sm'>
          <p className='mb-0'>
            Already have an account?{" "}
            <Link to='/sign-in' className='text-primary-600'>
              Sign In
            </Link>
          </p>
        </div>
      </form>
      </div>
    </div>

  );
};

export default SignUpPage;
